import { render } from "./Basicinfo.vue?vue&type=template&id=1a2d5ce2&scoped=true"
import script from "./Basicinfo.vue?vue&type=script&lang=js"
export * from "./Basicinfo.vue?vue&type=script&lang=js"

import "./Basicinfo.vue?vue&type=style&index=0&id=1a2d5ce2&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2d5ce2"]])

export default __exports__